export default __webpack_public_path__ + "static/media/IMG-2737.966b6c13.jpg";